<div class="py-1 ap-filter">
	<div class="filter_head flex justify-between items-center ">
		<h3 class="uppercase font-medium text-[0.9rem]">{{ control.name }}</h3>
		<div (click)="toggleCollapse()">
			<span *ngIf="collapse" class="cursor-pointer">
				<span class="plus_minus_icon plus material-symbols-outlined">add</span>
			</span>
			<span *ngIf="!collapse" class="cursor-pointer">
				<span class="plus_minus_icon plus material-symbols-outlined">remove</span>
			</span>
		</div>
	</div>
	<div class="ap-filter-item" [ngClass]="collapse ? 'filter_option_inner' : 'filter_option_inner active'">
		<fb-double-range-slider
			(minMaxRange)="onChange($event)"
			[ngClass]="collapse ? 'ap-filter-hide' : ''"
			[rangeInput]="control.values"></fb-double-range-slider>
	</div>
</div>
